<template>
<div class="bg-light">
  
  
  <Banner
    title="TrinPod"
    pricing="true"
    level="2"
    bg-color="#fff"
    class="sticky-top"
    />
  

  
  <div style="background-color: #ffb300; height: 16px;" />



  <TrinPodIntro>
    <div slot="header">
      <span class="red">TrinPod<sup>&trade;</sup></span>
    </div>
    <div slot="body" class="text-left">
      <p class="mb-5 font-weight-bold">TrinPod<sup>&trade;</sup> is an industrial strength Solid Pod acting as a digital twin of the various facilities you're working on.</p>
      <ul class="mb-5 text-left">
	<li>Conceptual computing through Trinity AI</li>
	<li>Capable of storing massive amounts of information</li>
      </ul>
    </div>
    <div slot="icon">
      <b-img
	:src="require('../assets/trinpod_secure.png')"
	style="max-width: 200px; width: 100%; height: auto;"
	/>
    </div>
  </TrinPodIntro>



  <b-container style="background-color: #ffb300; font-family: Arial, Helvetica, sans-serif; font-size: 1.2rem;" fluid>
    <b-row class="text-center">
      <b-col cols="12" lg="3">
	<b-button
	  size="lg"
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('access')"
	  >
	  <span class="link-ref-text">Solid Access</span>
	</b-button>
      </b-col>
      <b-col cols="12" lg="3">
	<b-button
	  size="lg"
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('inside')"
	  >
	  <span class="link-ref-text">Inside a TrinPod<sup>&trade;</sup></span>
	</b-button>
      </b-col>
      <b-col cols="12" lg="3">
	<b-button
	  size="lg"
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('enterprise')"
	  >	  
	  <span class="link-ref-text">Enterprise Grade</span>
	</b-button>
      </b-col>
      <b-col cols="12" lg="3">
	<b-button
	  size="lg"
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('one-world')"
	  >	  
	  <span class="link-ref-text">One-World Model</span>
	</b-button>
      </b-col>
    </b-row>
  </b-container>


  
  <ItShouldntControl />



  <div style="background-color: #ffb300; height: 16px;" />



  <IndustrialStrengthPod>
    <div slot="icon">
      <b-img
	  :src="require('../assets/trinpod_secure.png')"
	  style="height: 200px;"
	  />
    </div>
    <div slot="button">
      <div class="d-flex mx-auto my-3 py-5">
	<b-button
	  size="lg"
	  class="btn-orange mx-auto"
	  href="https://trinpod.us/pricing?industry=construction"
	  >
	  Get Started
	</b-button>
      </div>
    </div>
  </IndustrialStrengthPod>



  <div style="background-color: #ffb300; height: 16px;" ref="access" />



  <Imagine>
    <div slot="image">
      <b-img
	:src="require('../assets/how-to-construction-pod.png')"
	fluid
	/>
    </div>
  </Imagine>



  <div style="background-color: #ffb300; height: 16px;" ref="inside" />



  <WhatsInsideTrinPod>
    <div slot="icon">
      <b-img :src="require('../assets/trinpod_secure.png')" class="my-5" style="width: 200px;" />
    </div>
  </WhatsInsideTrinpod>



  <div style="background-color: #ffb300; height: 16px;" ref="enterprise" />
  


  <Layout06 checkColor="#ffb300">
    <div slot="icon">
      <b-img :src="require('../assets/trinpod_secure.png')" style="width: 220px;" />
    </div>
    <div slot="buttons">
      <div class="py-5">
	<b-button
	  size="lg"
	  class="btn-orange"
	  href="https://trinpod.us/pricing?industry=construction"
	  >
	  Get Started
	</b-button>      
      </div>
    </div>
  </Layout06>



  <div style="background-color: #ffb300; height: 16px;" ref="one-world" />
  


  <OneWorldModel industry="construction" />



  <div style="background-color: #ffb300; height: 16px;" />

  

  <Layout07>
    <div slot="icon">
      <b-img :src="require('../assets/trinpod_secure.png')" style="width: 114px;" />
    </div>
    <div slot="header">
      Two steps to get started
    </div>
    <div slot="list">
      <ol>
	<li>Get Started with TrinPod<sup>&trade;</sup></li>
	<li>Connect your Solid apps or get our TrinApp<sup>&trade;</sup> CDE<br> to manage your data and files.</li>
      </ol>
    </div>
  </Layout07>



  <Layout08 bg-color="#ffb300" >
    <div slot="header">Ready to own your data?</div>
    <div slot="buttons">
      <b-button
	size="lg"
	class="btn-outline-light text-dark px-5 mx-auto mr-sm-4 mb-2"
	href="https://forms.zohopublic.com/graphmetrix/form/ContactUs/formperma/4OMSwRrUmWo7aROfkChl9K7AVaPZWcvTwMOOtA41I6s"
	target="_blank"
	>
	Contact Us
      </b-button>
      <b-button
	size="lg"
	class="btn-outline-light text-dark px-5 mx-auto mr-sm-4 mb-2"
	to="/construction/trinapps"
	@click.native="scrollToTop()"
	>
	TrinApps
      </b-button>
      <b-button
	size="lg"
	class="btn-orange mb-2"
	href="https://trinpod.us/pricing?industry=construction"
	>
	Get Started
      </b-button>
    </div>
  </Layout08>


  
  <GmxFooter />


  
</div>
</template>

<script>
import GmxFooter from '@/components/footer.vue';
import Banner from '@/components/gmx-banner.vue';
import TrinPodIntro from '@/components/trinpod-intro.vue';
import ItShouldntControl from '@/components/it-shouldnt-control.vue';
import WhatsInsideTrinPod from '@/components/whats-inside-trinpod.vue';
import IndustrialStrengthPod from '@/components/industrial-strength-pod.vue';
import OneWorldModel from '@/components/one-world-model.vue';
import Imagine from '@/components/imagine.vue';
import Layout06 from '@/components/layout-06.vue';
import Layout07 from '@/components/layout-07.vue';
import Layout08 from '@/components/layout-08.vue';
import * as log from 'loglevel';
export default {
    name: "ConstructionTrinPod",
    components: {
	Banner,
	GmxFooter,
	TrinPodIntro,
	ItShouldntControl,
	WhatsInsideTrinPod,
	IndustrialStrengthPod,
	OneWorldModel,
	Imagine,
	Layout06,
	Layout07,
	Layout08
    },
    mounted () {
	window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy () {
	window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
	img: function (image) {
	    require(image)
	},
	onScroll: function () {
	    // Get the current scroll position
	    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
	    if (currentScrollPosition < 0) {
		return
	    }
	    // Stop executing this function if the difference between
	    // current scroll position and last scroll position is less than some offset
	    if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
		return
	    }
	    this.showVerticalRight = currentScrollPosition < this.lastScrollPosition
	    this.showNavbarLogo = currentScrollPosition > this.lastScrollPosition
	    this.lastScrollPosition = currentScrollPosition
	},
	goto: function (refName) {
    	    var element = this.$refs[refName];
	    //log.debug(element);
	    var top = element.offsetTop;
      
	    window.scrollTo(0, top);
	},
        scrollToTop: function () {
	    window.scrollTo(0,0);
        }
    }
}
</script>

